import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PublicRoutes from './routes/PublicRoutes';
import LoginAdmin from './pages/admin/LoginAdmin';
import RegisterAdmin from './pages/admin/RegisterAdmin';
import AdminLayout from './components/layout/AdminLayout';
import ProtectedRoute, { SuperAdminRoute } from './components/auth/ProtectedRoute';
import Dashboard from './pages/admin/Dashboard';

// Import komponen program
import ProgramList from './pages/admin/programs/ProgramList';
import ProgramForm from './pages/admin/programs/ProgramForm';
import CategoriesAdmin from './pages/admin/CategoriesAdmin';
import RuangAdmin from './pages/admin/RuangAdmin';
import ArticleAdmin from './pages/admin/ArticleAdmin';
import TasksAdmin from './pages/admin/TasksAdmin';
import SpeakersAdmin from './pages/admin/SpeakersAdmin';
import MembersAdmin from './pages/admin/MembersAdmin';
import LeadersAdmin from './pages/admin/LeadersAdmin';
import ReportsAdmin from './pages/admin/ReportsAdmin';
import SettingsAdmin from './pages/admin/SettingsAdmin';
import ScrollToTop from './components/common/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/*" element={<PublicRoutes />} />

        <Route path="/admin/login" element={<LoginAdmin />} />
        <Route path="/admin/register" element={<RegisterAdmin />} />

        {/* SEMUA RUTE ADMIN DILINDUNGI PROTECTED ROUTE */}
        <Route path="/admin" element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />

            {/* Rute CRUD Program */}
            <Route path="programs" element={<ProgramList />} />
            <Route path="programs/create" element={<ProgramForm />} />
            <Route path="programs/edit/:id" element={<ProgramForm />} />
            <Route path="categories" element={<CategoriesAdmin />} />

            {/* Rute Ruang Curhat Admin */}
            <Route path="ruang" element={<RuangAdmin />} />

            {/* Rute Moderasi Artikel */}
            <Route path="articles" element={<ArticleAdmin />} />

            {/* Rute Manajemen Tugas */}
            <Route path="tasks" element={<TasksAdmin />} />

            {/* Rute Manajemen Pembicara */}
            <Route path="speakers" element={<SpeakersAdmin />} />

            {/* Rute Manajemen Leaders */}
            <Route path="leaders" element={<LeadersAdmin />} />

            {/* RUTE KHUSUS SUPERADMIN: Member, Reports, Settings */}
            <Route element={<SuperAdminRoute />}>
              <Route path="members" element={<MembersAdmin />} />
              <Route path="reports" element={<ReportsAdmin />} />
              <Route path="settings" element={<SettingsAdmin />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;